import { VueModule } from '@Foundation/utilities';
import ProductHeader from './code/Scripts/components/product-header';

export default VueModule({
  components: {
    ProductHeader
  }
});
